/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PepsiCo Geospatial UAV API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  GetOrthoPresignedUrlsParams,
  GetOrthoStatusParams,
  GetOrthosParams,
  GetRawImagePresignedUrlsParams,
  HTTPValidationError,
  OrthoListItem,
  OrthoPresignedUrlItem,
  OrthoPresignedUrlResponse,
  OrthoResponse,
  OrthoStartRequest,
  OrthoStartResponse,
  OrthoStatusResponse,
  OrthoUploadCreateRequest,
  OrthoVisibilityUpdate,
  RawImagePresignedUrlItem,
  TaskResponse,
} from "../model";

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type getOrthosResponse200 = {
  data: OrthoListItem[];
  status: 200;
};

export type getOrthosResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getOrthosResponseSuccess = getOrthosResponse200 & {
  headers: Headers;
};
export type getOrthosResponseError = getOrthosResponse422 & {
  headers: Headers;
};

export type getOrthosResponse =
  getOrthosResponseSuccess | getOrthosResponseError;

export const getGetOrthosUrl = (params?: GetOrthosParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const arrayFormatParameters = ["status"];

    if (Array.isArray(value) && arrayFormatParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? "null" : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/orthos/?${stringifiedParams}`
    : `/api/orthos/`;
};

/**
 * @summary List orthos with optional location filter
 */
export const getOrthos = async (
  params?: GetOrthosParams,
  options?: RequestInit,
): Promise<getOrthosResponse> => {
  const res = await fetch(getGetOrthosUrl(params), {
    ...options,
    method: "GET",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getOrthosResponse["data"] = body ? JSON.parse(body) : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getOrthosResponse;
};

export const getGetOrthosQueryKey = (params?: GetOrthosParams) => {
  return [`/api/orthos/`, ...(params ? [params] : [])] as const;
};

export const getGetOrthosQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrthos>>,
  TError = HTTPValidationError,
>(
  params?: GetOrthosParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrthos>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrthosQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrthos>>> = ({
    signal,
  }) => getOrthos(params, { signal, ...fetchOptions });

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getOrthos>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetOrthosQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrthos>>
>;
export type GetOrthosQueryError = HTTPValidationError;

export function useGetOrthos<
  TData = Awaited<ReturnType<typeof getOrthos>>,
  TError = HTTPValidationError,
>(
  params: undefined | GetOrthosParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrthos>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrthos>>,
          TError,
          Awaited<ReturnType<typeof getOrthos>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrthos<
  TData = Awaited<ReturnType<typeof getOrthos>>,
  TError = HTTPValidationError,
>(
  params?: GetOrthosParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrthos>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrthos>>,
          TError,
          Awaited<ReturnType<typeof getOrthos>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrthos<
  TData = Awaited<ReturnType<typeof getOrthos>>,
  TError = HTTPValidationError,
>(
  params?: GetOrthosParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrthos>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List orthos with optional location filter
 */

export function useGetOrthos<
  TData = Awaited<ReturnType<typeof getOrthos>>,
  TError = HTTPValidationError,
>(
  params?: GetOrthosParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrthos>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetOrthosQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type createUploadingOrthoResponse200 = {
  data: OrthoResponse;
  status: 200;
};

export type createUploadingOrthoResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type createUploadingOrthoResponseSuccess =
  createUploadingOrthoResponse200 & {
    headers: Headers;
  };
export type createUploadingOrthoResponseError =
  createUploadingOrthoResponse422 & {
    headers: Headers;
  };

export type createUploadingOrthoResponse =
  createUploadingOrthoResponseSuccess | createUploadingOrthoResponseError;

export const getCreateUploadingOrthoUrl = () => {
  return `/api/orthos/`;
};

/**
 * Inserts an orthos row in uploading status and assigns its s3_uuid. The UI calls this before image upload. Raw images and later row snips are stored under uploads/{s3_uuid}/. ODM writes the stitched ortho under uploads/{s3_uuid}/ortho/.
 * @summary Create an ortho before image upload
 */
export const createUploadingOrtho = async (
  orthoUploadCreateRequest: OrthoUploadCreateRequest,
  options?: RequestInit,
): Promise<createUploadingOrthoResponse> => {
  const res = await fetch(getCreateUploadingOrthoUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(orthoUploadCreateRequest),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: createUploadingOrthoResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as createUploadingOrthoResponse;
};

export const getCreateUploadingOrthoMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createUploadingOrtho>>,
    TError,
    { data: OrthoUploadCreateRequest },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createUploadingOrtho>>,
  TError,
  { data: OrthoUploadCreateRequest },
  TContext
> => {
  const mutationKey = ["createUploadingOrtho"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createUploadingOrtho>>,
    { data: OrthoUploadCreateRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createUploadingOrtho(data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateUploadingOrthoMutationResult = NonNullable<
  Awaited<ReturnType<typeof createUploadingOrtho>>
>;
export type CreateUploadingOrthoMutationBody = OrthoUploadCreateRequest;
export type CreateUploadingOrthoMutationError = HTTPValidationError;

/**
 * @summary Create an ortho before image upload
 */
export const useCreateUploadingOrtho = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createUploadingOrtho>>,
      TError,
      { data: OrthoUploadCreateRequest },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createUploadingOrtho>>,
  TError,
  { data: OrthoUploadCreateRequest },
  TContext
> => {
  return useMutation(
    getCreateUploadingOrthoMutationOptions(options),
    queryClient,
  );
};
export type approveOrthoResponse200 = {
  data: OrthoResponse;
  status: 200;
};

export type approveOrthoResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type approveOrthoResponseSuccess = approveOrthoResponse200 & {
  headers: Headers;
};
export type approveOrthoResponseError = approveOrthoResponse422 & {
  headers: Headers;
};

export type approveOrthoResponse =
  approveOrthoResponseSuccess | approveOrthoResponseError;

export const getApproveOrthoUrl = (orthoId: number) => {
  return `/api/orthos/${orthoId}/approve`;
};

/**
 * Returns 409 when the ortho is still uploading or processing.
 * @summary Approve an ortho (superuser only)
 */
export const approveOrtho = async (
  orthoId: number,
  options?: RequestInit,
): Promise<approveOrthoResponse> => {
  const res = await fetch(getApproveOrthoUrl(orthoId), {
    ...options,
    method: "POST",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: approveOrthoResponse["data"] = body ? JSON.parse(body) : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as approveOrthoResponse;
};

export const getApproveOrthoMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approveOrtho>>,
    TError,
    { orthoId: number },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof approveOrtho>>,
  TError,
  { orthoId: number },
  TContext
> => {
  const mutationKey = ["approveOrtho"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof approveOrtho>>,
    { orthoId: number }
  > = (props) => {
    const { orthoId } = props ?? {};

    return approveOrtho(orthoId, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApproveOrthoMutationResult = NonNullable<
  Awaited<ReturnType<typeof approveOrtho>>
>;

export type ApproveOrthoMutationError = HTTPValidationError;

/**
 * @summary Approve an ortho (superuser only)
 */
export const useApproveOrtho = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof approveOrtho>>,
      TError,
      { orthoId: number },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof approveOrtho>>,
  TError,
  { orthoId: number },
  TContext
> => {
  return useMutation(getApproveOrthoMutationOptions(options), queryClient);
};
export type rejectOrthoResponse200 = {
  data: OrthoResponse;
  status: 200;
};

export type rejectOrthoResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type rejectOrthoResponseSuccess = rejectOrthoResponse200 & {
  headers: Headers;
};
export type rejectOrthoResponseError = rejectOrthoResponse422 & {
  headers: Headers;
};

export type rejectOrthoResponse =
  rejectOrthoResponseSuccess | rejectOrthoResponseError;

export const getRejectOrthoUrl = (orthoId: number) => {
  return `/api/orthos/${orthoId}/reject`;
};

/**
 * Sets the ortho to rejected, hides it from the map, and records the reviewer. Pending, processing, and completed raw_image_upload tasks for this ortho are marked superseded so those content hashes can be uploaded again. Returns 409 when the ortho is still uploading or processing.
 * @summary Reject an ortho (superuser only)
 */
export const rejectOrtho = async (
  orthoId: number,
  options?: RequestInit,
): Promise<rejectOrthoResponse> => {
  const res = await fetch(getRejectOrthoUrl(orthoId), {
    ...options,
    method: "POST",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: rejectOrthoResponse["data"] = body ? JSON.parse(body) : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as rejectOrthoResponse;
};

export const getRejectOrthoMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rejectOrtho>>,
    TError,
    { orthoId: number },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rejectOrtho>>,
  TError,
  { orthoId: number },
  TContext
> => {
  const mutationKey = ["rejectOrtho"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rejectOrtho>>,
    { orthoId: number }
  > = (props) => {
    const { orthoId } = props ?? {};

    return rejectOrtho(orthoId, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RejectOrthoMutationResult = NonNullable<
  Awaited<ReturnType<typeof rejectOrtho>>
>;

export type RejectOrthoMutationError = HTTPValidationError;

/**
 * @summary Reject an ortho (superuser only)
 */
export const useRejectOrtho = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof rejectOrtho>>,
      TError,
      { orthoId: number },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof rejectOrtho>>,
  TError,
  { orthoId: number },
  TContext
> => {
  return useMutation(getRejectOrthoMutationOptions(options), queryClient);
};
export type setOrthoVisibilityResponse200 = {
  data: OrthoResponse;
  status: 200;
};

export type setOrthoVisibilityResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type setOrthoVisibilityResponseSuccess =
  setOrthoVisibilityResponse200 & {
    headers: Headers;
  };
export type setOrthoVisibilityResponseError = setOrthoVisibilityResponse422 & {
  headers: Headers;
};

export type setOrthoVisibilityResponse =
  setOrthoVisibilityResponseSuccess | setOrthoVisibilityResponseError;

export const getSetOrthoVisibilityUrl = (orthoId: number) => {
  return `/api/orthos/${orthoId}/visibility`;
};

/**
 * @summary Set whether an ortho is shown on the map
 */
export const setOrthoVisibility = async (
  orthoId: number,
  orthoVisibilityUpdate: OrthoVisibilityUpdate,
  options?: RequestInit,
): Promise<setOrthoVisibilityResponse> => {
  const res = await fetch(getSetOrthoVisibilityUrl(orthoId), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(orthoVisibilityUpdate),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: setOrthoVisibilityResponse["data"] = body ? JSON.parse(body) : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as setOrthoVisibilityResponse;
};

export const getSetOrthoVisibilityMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setOrthoVisibility>>,
    TError,
    { orthoId: number; data: OrthoVisibilityUpdate },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setOrthoVisibility>>,
  TError,
  { orthoId: number; data: OrthoVisibilityUpdate },
  TContext
> => {
  const mutationKey = ["setOrthoVisibility"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setOrthoVisibility>>,
    { orthoId: number; data: OrthoVisibilityUpdate }
  > = (props) => {
    const { orthoId, data } = props ?? {};

    return setOrthoVisibility(orthoId, data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetOrthoVisibilityMutationResult = NonNullable<
  Awaited<ReturnType<typeof setOrthoVisibility>>
>;
export type SetOrthoVisibilityMutationBody = OrthoVisibilityUpdate;
export type SetOrthoVisibilityMutationError = HTTPValidationError;

/**
 * @summary Set whether an ortho is shown on the map
 */
export const useSetOrthoVisibility = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof setOrthoVisibility>>,
      TError,
      { orthoId: number; data: OrthoVisibilityUpdate },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof setOrthoVisibility>>,
  TError,
  { orthoId: number; data: OrthoVisibilityUpdate },
  TContext
> => {
  return useMutation(
    getSetOrthoVisibilityMutationOptions(options),
    queryClient,
  );
};
export type startOrthoCreationResponse200 = {
  data: OrthoStartResponse;
  status: 200;
};

export type startOrthoCreationResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type startOrthoCreationResponseSuccess =
  startOrthoCreationResponse200 & {
    headers: Headers;
  };
export type startOrthoCreationResponseError = startOrthoCreationResponse422 & {
  headers: Headers;
};

export type startOrthoCreationResponse =
  startOrthoCreationResponseSuccess | startOrthoCreationResponseError;

export const getStartOrthoCreationUrl = () => {
  return `/api/orthos/start`;
};

/**
 * Starts stitching the raw images already uploaded for an ortho in uploading status, and moves that ortho to processing. Returns 409 when that ortho is not uploading.
 * @summary Start orthophoto creation via ScaleODM
 */
export const startOrthoCreation = async (
  orthoStartRequest: OrthoStartRequest,
  options?: RequestInit,
): Promise<startOrthoCreationResponse> => {
  const res = await fetch(getStartOrthoCreationUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(orthoStartRequest),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: startOrthoCreationResponse["data"] = body ? JSON.parse(body) : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as startOrthoCreationResponse;
};

export const getStartOrthoCreationMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startOrthoCreation>>,
    TError,
    { data: OrthoStartRequest },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof startOrthoCreation>>,
  TError,
  { data: OrthoStartRequest },
  TContext
> => {
  const mutationKey = ["startOrthoCreation"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof startOrthoCreation>>,
    { data: OrthoStartRequest }
  > = (props) => {
    const { data } = props ?? {};

    return startOrthoCreation(data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StartOrthoCreationMutationResult = NonNullable<
  Awaited<ReturnType<typeof startOrthoCreation>>
>;
export type StartOrthoCreationMutationBody = OrthoStartRequest;
export type StartOrthoCreationMutationError = HTTPValidationError;

/**
 * @summary Start orthophoto creation via ScaleODM
 */
export const useStartOrthoCreation = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof startOrthoCreation>>,
      TError,
      { data: OrthoStartRequest },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof startOrthoCreation>>,
  TError,
  { data: OrthoStartRequest },
  TContext
> => {
  return useMutation(
    getStartOrthoCreationMutationOptions(options),
    queryClient,
  );
};
export type getOrthoStatusResponse200 = {
  data: OrthoStatusResponse;
  status: 200;
};

export type getOrthoStatusResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getOrthoStatusResponseSuccess = getOrthoStatusResponse200 & {
  headers: Headers;
};
export type getOrthoStatusResponseError = getOrthoStatusResponse422 & {
  headers: Headers;
};

export type getOrthoStatusResponse =
  getOrthoStatusResponseSuccess | getOrthoStatusResponseError;

export const getGetOrthoStatusUrl = (
  taskId: number,
  params?: GetOrthoStatusParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/orthos/${taskId}/status?${stringifiedParams}`
    : `/api/orthos/${taskId}/status`;
};

/**
 * Report console output, progress and stage for any ortho_creation task.
 *
 * Output comes from ScaleODM's ``/task/{uuid}/output``; progress and stage
 * are parsed from it.
 *
 * Authenticated, but not restricted to the task owner — any signed-in user
 * may poll status for any ortho task.
 * @summary ScaleODM console output, progress and stage for an ortho task
 */
export const getOrthoStatus = async (
  taskId: number,
  params?: GetOrthoStatusParams,
  options?: RequestInit,
): Promise<getOrthoStatusResponse> => {
  const res = await fetch(getGetOrthoStatusUrl(taskId, params), {
    ...options,
    method: "GET",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getOrthoStatusResponse["data"] = body ? JSON.parse(body) : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getOrthoStatusResponse;
};

export const getGetOrthoStatusQueryKey = (
  taskId: number,
  params?: GetOrthoStatusParams,
) => {
  return [`/api/orthos/${taskId}/status`, ...(params ? [params] : [])] as const;
};

export const getGetOrthoStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrthoStatus>>,
  TError = HTTPValidationError,
>(
  taskId: number,
  params?: GetOrthoStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrthoStatus>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetOrthoStatusQueryKey(taskId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrthoStatus>>> = ({
    signal,
  }) => getOrthoStatus(taskId, params, { signal, ...fetchOptions });

  return {
    queryKey,
    queryFn,
    enabled: taskId !== null && taskId !== undefined,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrthoStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrthoStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrthoStatus>>
>;
export type GetOrthoStatusQueryError = HTTPValidationError;

export function useGetOrthoStatus<
  TData = Awaited<ReturnType<typeof getOrthoStatus>>,
  TError = HTTPValidationError,
>(
  taskId: number,
  params: undefined | GetOrthoStatusParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrthoStatus>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrthoStatus>>,
          TError,
          Awaited<ReturnType<typeof getOrthoStatus>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrthoStatus<
  TData = Awaited<ReturnType<typeof getOrthoStatus>>,
  TError = HTTPValidationError,
>(
  taskId: number,
  params?: GetOrthoStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrthoStatus>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrthoStatus>>,
          TError,
          Awaited<ReturnType<typeof getOrthoStatus>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrthoStatus<
  TData = Awaited<ReturnType<typeof getOrthoStatus>>,
  TError = HTTPValidationError,
>(
  taskId: number,
  params?: GetOrthoStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrthoStatus>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary ScaleODM console output, progress and stage for an ortho task
 */

export function useGetOrthoStatus<
  TData = Awaited<ReturnType<typeof getOrthoStatus>>,
  TError = HTTPValidationError,
>(
  taskId: number,
  params?: GetOrthoStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrthoStatus>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetOrthoStatusQueryOptions(taskId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type restartOrthoScaleodmTaskResponse200 = {
  data: TaskResponse;
  status: 200;
};

export type restartOrthoScaleodmTaskResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type restartOrthoScaleodmTaskResponseSuccess =
  restartOrthoScaleodmTaskResponse200 & {
    headers: Headers;
  };
export type restartOrthoScaleodmTaskResponseError =
  restartOrthoScaleodmTaskResponse422 & {
    headers: Headers;
  };

export type restartOrthoScaleodmTaskResponse =
  | restartOrthoScaleodmTaskResponseSuccess
  | restartOrthoScaleodmTaskResponseError;

export const getRestartOrthoScaleodmTaskUrl = (taskId: number) => {
  return `/api/orthos/${taskId}/restart`;
};

/**
 * Delete and recreate the underlying ScaleODM job for an ortho task.
 *
 * The current ScaleODM job (if any) is identified by our task id via
 * ScaleODM's ``name`` field rather than a locally stored uuid, so this
 * works even if the original job's uuid was never persisted.
 * @summary Restart a stalled or failed ScaleODM task (superuser only)
 */
export const restartOrthoScaleodmTask = async (
  taskId: number,
  options?: RequestInit,
): Promise<restartOrthoScaleodmTaskResponse> => {
  const res = await fetch(getRestartOrthoScaleodmTaskUrl(taskId), {
    ...options,
    method: "POST",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: restartOrthoScaleodmTaskResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as restartOrthoScaleodmTaskResponse;
};

export const getRestartOrthoScaleodmTaskMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restartOrthoScaleodmTask>>,
    TError,
    { taskId: number },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof restartOrthoScaleodmTask>>,
  TError,
  { taskId: number },
  TContext
> => {
  const mutationKey = ["restartOrthoScaleodmTask"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof restartOrthoScaleodmTask>>,
    { taskId: number }
  > = (props) => {
    const { taskId } = props ?? {};

    return restartOrthoScaleodmTask(taskId, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RestartOrthoScaleodmTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof restartOrthoScaleodmTask>>
>;

export type RestartOrthoScaleodmTaskMutationError = HTTPValidationError;

/**
 * @summary Restart a stalled or failed ScaleODM task (superuser only)
 */
export const useRestartOrthoScaleodmTask = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof restartOrthoScaleodmTask>>,
      TError,
      { taskId: number },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof restartOrthoScaleodmTask>>,
  TError,
  { taskId: number },
  TContext
> => {
  return useMutation(
    getRestartOrthoScaleodmTaskMutationOptions(options),
    queryClient,
  );
};
export type getRawImagePresignedUrlsResponse200 = {
  data: RawImagePresignedUrlItem[];
  status: 200;
};

export type getRawImagePresignedUrlsResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getRawImagePresignedUrlsResponseSuccess =
  getRawImagePresignedUrlsResponse200 & {
    headers: Headers;
  };
export type getRawImagePresignedUrlsResponseError =
  getRawImagePresignedUrlsResponse422 & {
    headers: Headers;
  };

export type getRawImagePresignedUrlsResponse =
  | getRawImagePresignedUrlsResponseSuccess
  | getRawImagePresignedUrlsResponseError;

export const getGetRawImagePresignedUrlsUrl = (
  params: GetRawImagePresignedUrlsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/orthos/raw/urls?${stringifiedParams}`
    : `/api/orthos/raw/urls`;
};

/**
 * Lists objects under uploads/{s3_uuid}/raw/ using the ortho's s3_uuid and returns a presigned S3 GET URL for each raw_image_upload object. Returns 404 when the ortho does not exist or that prefix has no images.
 * @summary Get presigned URLs to read an ortho's raw images
 */
export const getRawImagePresignedUrls = async (
  params: GetRawImagePresignedUrlsParams,
  options?: RequestInit,
): Promise<getRawImagePresignedUrlsResponse> => {
  const res = await fetch(getGetRawImagePresignedUrlsUrl(params), {
    ...options,
    method: "GET",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getRawImagePresignedUrlsResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getRawImagePresignedUrlsResponse;
};

export const getGetRawImagePresignedUrlsQueryKey = (
  params?: GetRawImagePresignedUrlsParams,
) => {
  return [`/api/orthos/raw/urls`, ...(params ? [params] : [])] as const;
};

export const getGetRawImagePresignedUrlsQueryOptions = <
  TData = Awaited<ReturnType<typeof getRawImagePresignedUrls>>,
  TError = HTTPValidationError,
>(
  params: GetRawImagePresignedUrlsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRawImagePresignedUrls>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRawImagePresignedUrlsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRawImagePresignedUrls>>
  > = ({ signal }) =>
    getRawImagePresignedUrls(params, { signal, ...fetchOptions });

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getRawImagePresignedUrls>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRawImagePresignedUrlsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRawImagePresignedUrls>>
>;
export type GetRawImagePresignedUrlsQueryError = HTTPValidationError;

export function useGetRawImagePresignedUrls<
  TData = Awaited<ReturnType<typeof getRawImagePresignedUrls>>,
  TError = HTTPValidationError,
>(
  params: GetRawImagePresignedUrlsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRawImagePresignedUrls>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRawImagePresignedUrls>>,
          TError,
          Awaited<ReturnType<typeof getRawImagePresignedUrls>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRawImagePresignedUrls<
  TData = Awaited<ReturnType<typeof getRawImagePresignedUrls>>,
  TError = HTTPValidationError,
>(
  params: GetRawImagePresignedUrlsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRawImagePresignedUrls>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRawImagePresignedUrls>>,
          TError,
          Awaited<ReturnType<typeof getRawImagePresignedUrls>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRawImagePresignedUrls<
  TData = Awaited<ReturnType<typeof getRawImagePresignedUrls>>,
  TError = HTTPValidationError,
>(
  params: GetRawImagePresignedUrlsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRawImagePresignedUrls>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get presigned URLs to read an ortho's raw images
 */

export function useGetRawImagePresignedUrls<
  TData = Awaited<ReturnType<typeof getRawImagePresignedUrls>>,
  TError = HTTPValidationError,
>(
  params: GetRawImagePresignedUrlsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRawImagePresignedUrls>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetRawImagePresignedUrlsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type getOrthoPresignedUrlsResponse200 = {
  data: OrthoPresignedUrlItem[];
  status: 200;
};

export type getOrthoPresignedUrlsResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getOrthoPresignedUrlsResponseSuccess =
  getOrthoPresignedUrlsResponse200 & {
    headers: Headers;
  };
export type getOrthoPresignedUrlsResponseError =
  getOrthoPresignedUrlsResponse422 & {
    headers: Headers;
  };

export type getOrthoPresignedUrlsResponse =
  getOrthoPresignedUrlsResponseSuccess | getOrthoPresignedUrlsResponseError;

export const getGetOrthoPresignedUrlsUrl = (
  params?: GetOrthoPresignedUrlsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const arrayFormatParameters = ["ortho_id"];

    if (Array.isArray(value) && arrayFormatParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? "null" : String(v));
      });
      return;
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/orthos/urls?${stringifiedParams}`
    : `/api/orthos/urls`;
};

/**
 * Returns presigned S3 GET URLs for the requested ortho ids. Unknown ids are omitted.
 * @summary Get presigned URLs to read multiple ortho COGs
 */
export const getOrthoPresignedUrls = async (
  params?: GetOrthoPresignedUrlsParams,
  options?: RequestInit,
): Promise<getOrthoPresignedUrlsResponse> => {
  const res = await fetch(getGetOrthoPresignedUrlsUrl(params), {
    ...options,
    method: "GET",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getOrthoPresignedUrlsResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getOrthoPresignedUrlsResponse;
};

export const getGetOrthoPresignedUrlsQueryKey = (
  params?: GetOrthoPresignedUrlsParams,
) => {
  return [`/api/orthos/urls`, ...(params ? [params] : [])] as const;
};

export const getGetOrthoPresignedUrlsQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrthoPresignedUrls>>,
  TError = HTTPValidationError,
>(
  params?: GetOrthoPresignedUrlsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrthoPresignedUrls>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetOrthoPresignedUrlsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOrthoPresignedUrls>>
  > = ({ signal }) =>
    getOrthoPresignedUrls(params, { signal, ...fetchOptions });

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrthoPresignedUrls>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrthoPresignedUrlsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrthoPresignedUrls>>
>;
export type GetOrthoPresignedUrlsQueryError = HTTPValidationError;

export function useGetOrthoPresignedUrls<
  TData = Awaited<ReturnType<typeof getOrthoPresignedUrls>>,
  TError = HTTPValidationError,
>(
  params: undefined | GetOrthoPresignedUrlsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrthoPresignedUrls>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrthoPresignedUrls>>,
          TError,
          Awaited<ReturnType<typeof getOrthoPresignedUrls>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrthoPresignedUrls<
  TData = Awaited<ReturnType<typeof getOrthoPresignedUrls>>,
  TError = HTTPValidationError,
>(
  params?: GetOrthoPresignedUrlsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrthoPresignedUrls>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrthoPresignedUrls>>,
          TError,
          Awaited<ReturnType<typeof getOrthoPresignedUrls>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrthoPresignedUrls<
  TData = Awaited<ReturnType<typeof getOrthoPresignedUrls>>,
  TError = HTTPValidationError,
>(
  params?: GetOrthoPresignedUrlsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrthoPresignedUrls>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get presigned URLs to read multiple ortho COGs
 */

export function useGetOrthoPresignedUrls<
  TData = Awaited<ReturnType<typeof getOrthoPresignedUrls>>,
  TError = HTTPValidationError,
>(
  params?: GetOrthoPresignedUrlsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrthoPresignedUrls>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetOrthoPresignedUrlsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type getOrthoPresignedUrlResponse200 = {
  data: OrthoPresignedUrlResponse;
  status: 200;
};

export type getOrthoPresignedUrlResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getOrthoPresignedUrlResponseSuccess =
  getOrthoPresignedUrlResponse200 & {
    headers: Headers;
  };
export type getOrthoPresignedUrlResponseError =
  getOrthoPresignedUrlResponse422 & {
    headers: Headers;
  };

export type getOrthoPresignedUrlResponse =
  getOrthoPresignedUrlResponseSuccess | getOrthoPresignedUrlResponseError;

export const getGetOrthoPresignedUrlUrl = (orthoId: number) => {
  return `/api/orthos/${orthoId}`;
};

/**
 * Returns a short-lived S3 presigned GET URL for the ortho's cloud-optimized GeoTIFF. The UI can use this URL for full GETs and HTTP Range requests.
 * @summary Get a presigned URL to read an ortho COG
 */
export const getOrthoPresignedUrl = async (
  orthoId: number,
  options?: RequestInit,
): Promise<getOrthoPresignedUrlResponse> => {
  const res = await fetch(getGetOrthoPresignedUrlUrl(orthoId), {
    ...options,
    method: "GET",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getOrthoPresignedUrlResponse["data"] = body
    ? JSON.parse(body)
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getOrthoPresignedUrlResponse;
};

export const getGetOrthoPresignedUrlQueryKey = (orthoId: number) => {
  return [`/api/orthos/${orthoId}`] as const;
};

export const getGetOrthoPresignedUrlQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrthoPresignedUrl>>,
  TError = HTTPValidationError,
>(
  orthoId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrthoPresignedUrl>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetOrthoPresignedUrlQueryKey(orthoId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOrthoPresignedUrl>>
  > = ({ signal }) =>
    getOrthoPresignedUrl(orthoId, { signal, ...fetchOptions });

  return {
    queryKey,
    queryFn,
    enabled: orthoId !== null && orthoId !== undefined,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrthoPresignedUrl>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrthoPresignedUrlQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrthoPresignedUrl>>
>;
export type GetOrthoPresignedUrlQueryError = HTTPValidationError;

export function useGetOrthoPresignedUrl<
  TData = Awaited<ReturnType<typeof getOrthoPresignedUrl>>,
  TError = HTTPValidationError,
>(
  orthoId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrthoPresignedUrl>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrthoPresignedUrl>>,
          TError,
          Awaited<ReturnType<typeof getOrthoPresignedUrl>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrthoPresignedUrl<
  TData = Awaited<ReturnType<typeof getOrthoPresignedUrl>>,
  TError = HTTPValidationError,
>(
  orthoId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrthoPresignedUrl>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrthoPresignedUrl>>,
          TError,
          Awaited<ReturnType<typeof getOrthoPresignedUrl>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrthoPresignedUrl<
  TData = Awaited<ReturnType<typeof getOrthoPresignedUrl>>,
  TError = HTTPValidationError,
>(
  orthoId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrthoPresignedUrl>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get a presigned URL to read an ortho COG
 */

export function useGetOrthoPresignedUrl<
  TData = Awaited<ReturnType<typeof getOrthoPresignedUrl>>,
  TError = HTTPValidationError,
>(
  orthoId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrthoPresignedUrl>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetOrthoPresignedUrlQueryOptions(orthoId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}
